import { useMemo, useState } from "react";
import * as E from "@numi/engine";
import { useApp, go } from "../store.ts";
import { Card, Html, Icon, Numi } from "../ui.tsx";
import { SFX } from "../sound.ts";
import { sayAloud } from "../question.ts";
import { finishWrap, loadPlan, teachBack } from "../plan.ts";

const FEEL: [string, string][] = [
  ["Easy", "Good to know. Next time we'll go a step harder."],
  ["Just right", "That's the best place to learn: not too easy, not too hard."],
  ["Tricky", "Tricky means your brain is working hard. We'll come back to it next time, a bit slower."],
];

/** End of today's lesson: a short reflection, then something to teach a grown-up. */
export function Wrap() {
  const s = useApp(); const p = loadPlan(); const focus = E.topic(p.focus)!; const next = p.next ? E.topic(p.next) : null;
  const [feel, setFeel] = useState(p.feeling || ""); const q = useMemo(() => teachBack(), []);
  const pick = (f: string, reply: string) => { SFX.tap(); setFeel(f); finishWrap(f); sayAloud(reply); };
  return <main><Card className="wrap">
    <div className="say"><Numi size={80} mood="fly" /><div className="speech">
      <b>That's today's lesson done, {s.child!.name}.</b> You worked on {E.topicTitle(focus).toLowerCase()} and earned {s.todayStars} star{s.todayStars === 1 ? "" : "s"} today.</div></div>
    <h3>How did it feel?</h3>
    <div className="row feel">{FEEL.map(([f, r]) => <button key={f} className={`btn ${feel === f ? "yellow" : "soft"}`} aria-pressed={feel === f} onClick={() => pick(f, r)}>{f}</button>)}</div>
    {feel && <p className="note">{FEEL.find((x) => x[0] === feel)![1]}</p>}
    <div className="teach"><h3><Icon name="speak" /> Teach it to a grown-up</h3>
      <p>Show a grown-up how you would solve this. Say each step out loud, then ask them to try one on you.</p>
      <Html as="p" className="qtext" html={q.text} />{q.viz && <Html className="vizbox sm" html={q.viz} />}
      <details><summary>Check the answer</summary><p>{q.explain}</p></details></div>
    {next && <p className="note">Next time with Numi: <b>{E.topicTitle(next)}</b>.</p>}
    <div className="row center"><button className="btn yellow big" disabled={!feel} onClick={() => go("home")}><Icon name="home" /> {feel ? "Back home" : "Pick how it felt first"}</button></div>
  </Card></main>;
}
